import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";

import {EmailIcon} from "../../styles/icons";

const ViewMessagesButton = props => {
  const {iconOnly, textOnly, isPatient} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const providerId = (
    isString(props.providerId) || isNumber(props.providerId)
    ? props.providerId
    : get(props, 'provider.id')
  ) || '';
  const url = (
    patientId && !isPatient
    ? `/providers/patients/messages/${patientId}`
    : `/clients/messages/${providerId}`
  );
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    sx: props.sx,
    disabled: !patientId && !providerId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <EmailIcon />,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  return (
    iconOnly
    ? <Tooltip title='Message'>
      <IconButton {...childProps}>
        <EmailIcon fill={props.fill || 'var(--primary)'}/>
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
        Message
    </Button>
  );
};

ViewMessagesButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

ViewMessagesButton.propTypes = {
  provider: PropTypes.object,
  providerId: PropTypes.object,
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default ViewMessagesButton;
